<template>
	<PopupRouterView :showLeftIcon="true" label="Finish Good Quality Inspection Input" okTitle="Save"
		cancelTitle="Cancel" entityName="finishgoodqualityinspection" :documentId="mainRecordId"
		@saveMethod="saveAction" @hideMethod="onHidden" ref="finishGoodQualityInspectionInput"
		modalClass="input-scan-page">


		<span v-if="scanPageIndex == 1">
			<b-row>
				<b-col cols="12">
					<app-input-scan id="fieldset-control-card" ref="fieldset-control-card"
						:model.sync="controlCardQrCode" label="Control Card" @scannedMethod="goToNext(2)"
						:isBusy="isScanControlCardLoading" autofocus />
				</b-col>
				<b-col cols="12">
					<app-list :isDataLoading="isControlCardsLoading" :dataCount="controlCards.length">
						<b-list-group-item>
							<div class="list-title" v-for="(item, index) in controlCards" :key="index" @click="goToNext(2, item)">
								<b-row>
									<b-col cols="12">
										{{ item.controlCardNumber }}
										<hr />
									</b-col>
								</b-row>
							</div>
						</b-list-group-item>
					</app-list>
				</b-col>
				<b-col cols="12">
					<app-table-input-custom 
						title = "Scanned Control Card"
						:bordered="true" :items="finishGoodQcConfirmationDetails" 
						:fields="fieldsFinishGoodQcConfirmation" 
						:busy="isDataLoading" 
						:sort-by.sync="sortBy" 
						:sort-desc.sync="sortDesc" small responsive
						@deleteButtonMethod="deleteFinishGoodQcConfirmation"	
						@showPopupAddMethod="addDataFinishGoodQcConfirmation"	
						:showActionButton="false"
						:showDeleteButton="false"
						:showAddButton="false"
						:showAddFromClipboardButton="false"	
						:showReplaceFromClipboardButton="false"	
						:showUploadButton="false"	
						:showDownloadButton="false">						
							
						<!-- <template v-slot:cell(no)="row">
							{{ ((row.index + 1) + ( workOrderExecutionNgPageSize2 * (currentWorkOrderExecutionNgPage2 - 1))) }}
						</template> -->
											
						<template v-slot:table-busys>
							<div class="text-center my-2">
								<b-spinner class="align-middle text-primary"></b-spinner>
								<strong class="ml-2">Loading...</strong>
							</div>
						</template>
											
						<template v-slot:cell(mcc)="row">
							<app-label label-cols-lg="12" size="md" label="MCC" :model="row.item.controlCard != null ? row.item.controlCard.controlCardNumber : ''" :nolabel="true" />
						</template>
						<template v-slot:cell(status)="row">
							<!-- <app-label label-cols-lg="12" size="md" label="Ng Qty" :model="row.item.ngQty" :nolabel="true" /> -->
							<app-label label-cols-lg="12" size="md" label="Control Card Status" :model="row.item.finishGoodQualityInspection != null ? row.item.finishGoodQualityInspection.name : ''" :nolabel="true" />
						</template>
					</app-table-input-custom>
				</b-col>
			</b-row>
		</span>
		<span v-if="scanPageIndex == 2">
			<b-row>
				<b-col cols="12">
					<app-label id="fieldset-control-card-number" label-cols-lg="12" label="Control Card"
						label-for="input-control-card" size="sm"
						:model="model.controlCard != null ? model.controlCard.controlCardNumber : ''"
						:isEditable="false" />
					<app-label id="fieldset-part-number" label-cols-lg="12" label="Part Number"
						label-for="input-part-number" size="sm"
						:model="(model.controlCard != null && model.controlCard.part != null) ? model.controlCard.part.partNumber : ''"
						:isEditable="false" />
					<app-label id="fieldset-customer" label-cols-lg="12" label="Customer" label-for="input-customer"
						size="sm"
						:model="(model.controlCard != null && model.controlCard.part != null && model.controlCard.part.customer != null) ? model.controlCard.part.customer.name : ''"
						:isEditable="false" />
					<app-label id="fieldset-start-time" label-cols-lg="12" label="Start Time" label-for="input-qty-ng"
						size="sm" :model="formatDate(model.createdDate)" :isEditable="false" />
					<app-label id="fieldset-qty-case" label-cols-lg="12" label="Qty Case" label-for="input-qty-ng"
						size="sm" :model="(model.controlCard != null) ? model.controlCard.qtyCase : 0"
						:isEditable="false" />
					<app-input-radio :options="metodeQcs" text-field="name" value-field="id" label-cols-lg="12"
						label="Metode Qc" id="fieldset-metode-qc" size="sm" :model.sync="model.metodeQcId" :isRequired="true"
						@change="updateData" />
					<app-input-textbox id="fieldset-qty-ok" label-cols-lg="12" label="Qty Ok" label-for="input-qty-ok"
						size="sm" :model.sync="model.qtyAfter" :isEditable="true" :state="validateState('qtyAfter')"
						:errorMessage="getErrorMessage(errorMessage.qtyAfter, 'qtyAfter')" @change="updateData"
						:isRequired="true" type="number" />
					<app-input-textbox id="fieldset-qty-pending" label-cols-lg="12" label="Qty Pending"
						label-for="input-qty-pending" size="sm" :model.sync="model.qtyPending" :isEditable="true"
						:state="validateState('qtyPending')"
						:errorMessage="getErrorMessage(errorMessage.qtyPending, 'qtyPending')" @change="updateData"
						type="number" />
				</b-col>
			</b-row>
		</span>
		<div v-if="scanPageIndex == 2">
			<app-table-input-custom title="Finish Good Quality Inspection Ng" :bordered="true"
			:items="finishGoodQualityInspectionNgs" :fields="fieldsFinishGoodQualityInspectionNg"
			:busy="isDataLoading" :sort-by.sync="sortByFinishGoodQualityInspectionNg"
			:sort-desc.sync="sortDescFinishGoodQualityInspectionNg" small responsive
			@editButtonMethod="editRowDataFinishGoodQualityInspectionNg"
			@deleteButtonMethod="deleteRowDataFinishGoodQualityInspectionNg"
			@showPopupAddMethod="addDataFinishGoodQualityInspectionNg()"
			@showPopupUploadMethod="showPopupUploadFinishGoodQualityInspectionNg()"
			@downloadMethod="downloadFinishGoodQualityInspectionNg()"
			@addFromClipboardMethod="addFromClipboardFinishGoodQualityInspectionNg()"
			@replaceFromClipboardMethod="replaceFromClipboardFinishGoodQualityInspectionNg()"
			:showActionButton="true" :showDeleteButton="true" :showAddButton="true"
			:showAddFromClipboardButton="false" :showReplaceFromClipboardButton="false" :showUploadButton="false"
			:showDownloadButton="false" :isDownloadBusy="isDownloadFinishGoodQualityInspectionNg">

			<!-- <template v-slot:head(actions)>
				<b-button @click="isShowFinishGoodQualityInspectionNgFilter = !isShowFinishGoodQualityInspectionNgFilter" class="float-right" size="sm"><b-icon-funnel-fill /></b-button>
			</template>  -->

			<template #top-row v-if="isShowFinishGoodQualityInspectionNgFilter">
				<b-th></b-th>
				<b-th stacked-heading="Problem Category">
					<v-select id="input-finish-good-quality-inspection-ng-problem-category-table" append-to-body
						label="code" :options="problemCategorys"
						:value="filterFinishGoodQualityInspectionNg.problemCategoryId" :reduce="item => item.id"
						v-model="filterFinishGoodQualityInspectionNg.problemCategoryId"
						@search="getProblemCategorys" :filterable="true"></v-select>
				</b-th>
				<b-th stacked-heading="Qty Ng">
					<b-form-input id="input-finish-good-quality-inspection-ng-qty-ng-table"
						v-model="filterFinishGoodQualityInspectionNg.qtyNg" size="sm" :type="number"></b-form-input>
				</b-th>

				<b-th></b-th>
			</template>

			<template v-slot:cell(no)="row">
				{{ ((row.index + 1) + (finishGoodQualityInspectionNgPageSize *
	(currentFinishGoodQualityInspectionNgPage - 1))) }}
			</template>

			<template v-slot:table-busys>
				<div class="text-center my-2">
					<b-spinner class="align-middle text-primary"></b-spinner>
					<strong class="ml-2">Loading...</strong>
				</div>
			</template>

			<template v-slot:cell(problemCategory)="row">
				<app-input-combobox-autocomplete :options="problemCategorys" optionsLabel="name" optionsKey="id"
					:id="'input-finish-good-quality-inspection-ng-problem-category-' + row.index" label-cols-lg="12"
					label="Problem Category" size="sm" :model.sync="row.item.problemCategoryId"
					:state="validateState('problemCategoryId')"
					:errorMessage="getErrorMessage(errorMessage.problemCategoryId, 'problemCategoryId')"
					@change="saveInputFinishGoodQualityInspectionNg(row.item)"
					:selected="row.item.problemCategory != null ? row.item.problemCategory.name : ''"
					@input="getProblemCategorys" :loading="isProblemCategoryComboLoading" :reloadData="true"
					:nolabel="true" />
			</template>
			<template v-slot:cell(qtyNg)="row">
				<app-input-textbox :id="'input-finish-good-quality-inspection-ng-qty-ng-' + row.index"
					label-cols-lg="12" label="Qty Ng" size="sm" :model.sync="row.item.qtyNg"
					@change="saveInputFinishGoodQualityInspectionNg(row.item)" :nolabel="true" type="number" />
			</template>
			<template v-slot:cell(evidence)="row">
				<app-input-fileupload :id="'input-evidence-attachment-file-pendukung-' + row.index" label-cols-lg="12" label="File Pendukung" size="sm" :model.sync="filePendukungs[row.item.id]" :currentModel="row.item.evidence" @change="saveInputEvidenceAttachment(row.item)" :isEditable="true"  :nolabel="true" accept="image/*" />
			</template>


			<template v-slot:form-add-detail>
				<FinishGoodQualityInspectionNgInput :model="modelFinishGoodQualityInspectionNg"
					:openPopup="isShowPopupFinishGoodQualityInspectionNg" @resetMethod="resetModal"
					@addButtonMethod="addRowDataFinishGoodQualityInspectionNg" />
			</template>
			<template v-slot:upload-detail>
				<FinishGoodQualityInspectionNgUpload :openPopup="isShowPopupUploadFinishGoodQualityInspectionNg"
					@resetMethod="resetModal" @uploadButtonMethod="uploadDataFinishGoodQualityInspectionNg"
					:parentId="modelId" />
			</template>
			</app-table-input-custom>
		</div>

		<b-overlay :show="isBusy" no-wrap></b-overlay>
		<template #modal-action-button>
			<b-button :disabled="!hasContent" v-if="scanPageIndex == 1" size="sm" class="btn-fill-success float-right" @click="finishAndSubmit">
				Finish
			</b-button>
			<b-button v-if="scanPageIndex == 2" size="sm" class="btn-fill-danger float-right mr-1"
				@click="goToNext(1)">Back</b-button>
			<b-button v-if="scanPageIndex == 2" size="sm" class="btn-fill-success float-right"
				@click="saveAction()">Finish Scan</b-button>

		</template>
	</PopupRouterView>
</template>
<script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import FinishGoodQualityInspection from '@/models/FinishGoodQualityInspection/FinishGoodQualityInspection';
import FinishGoodQualityInspectionList from '@/models/FinishGoodQualityInspection/FinishGoodQualityInspectionList';
import FinishGoodQualityInspectionFilter from '@/filters/FinishGoodQualityInspection/FinishGoodQualityInspectionFilter';

import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import ControlCard from '@/models/ControlCard/ControlCard';
import ControlCardType from '@/models/ControlCardType/ControlCardType';
import ControlCardFilter from '@/filters/ControlCard/ControlCardFilter';
import AppInputTextbox from '@/components/AppInputTextbox';
import AppInputRadio from '@/components/AppInputRadio';
import MetodeQc from '@/models/MetodeQc/MetodeQc';
import MetodeQcFilter from '@/filters/MetodeQc/MetodeQcFilter';
import Part from '@/models/Part/Part';
import PartFilter from '@/filters/Part/PartFilter';
import WorkOrderProcessDetail from '@/models/WorkOrderProcess/WorkOrderProcessDetail';
import WorkOrderProcessDetailFilter from '@/filters/WorkOrderProcess/WorkOrderProcessDetailFilter';
import FinishGoodQualityInspectionNg from '@/models/FinishGoodQualityInspection/FinishGoodQualityInspectionNg';
import FinishGoodQualityInspectionNgFilter from '@/filters/FinishGoodQualityInspection/FinishGoodQualityInspectionNgFilter';
import ProblemCategory from '@/models/ProblemCategory/ProblemCategory';
import ProblemCategoryFilter from '@/filters/ProblemCategory/ProblemCategoryFilter';
import AppTableInput from '@/components/AppTableInput';
import AppTableInputCustom from '@/components/AppTableInputCustom';
import AppTableInputPopup from '@/components/AppTableInputPopup';
import FinishGoodQualityInspectionNgInput from '@/views/FinishGoodQualityInspection/FinishGoodQualityInspectionNgInput';
import FinishGoodQualityInspectionNgUpload from '@/views/FinishGoodQualityInspection/FinishGoodQualityInspectionNgUpload';
import PopupRouterView from '@/components/PopupRouterView';
import AppInputScan from '@/components/AppInputScan';
import AppList from '@/components/AppList';
import toast from '@/mixins/toastMixin';
import AppLabel from '@/components/AppLabel';
import moment from 'moment';
import AppInputFileupload from '@/components/AppInputFileupload';


const validateQty = function (qty) {
	if (qty < 0) {
		return false;
	}

	return true;
}

export default {
	components: {
		AppInputComboboxAutocomplete,
		AppInputTextbox,
		AppInputRadio,
		FinishGoodQualityInspectionNgInput, FinishGoodQualityInspectionNgUpload,
		AppTableInput,
		AppTableInputCustom,
		AppTableInputPopup,
		PopupRouterView,
		AppInputScan,
		AppList,
		AppLabel,
		AppInputFileupload,
	},
	mixins: [validationMixin, toast],
	validations: {
		model: {
			qtyAfter: { validateQty, required },
			qtyPending: { validateQty }
		},
	},
	data() {
		return {
			errorMessage: {
				qtyAfter: { validateQty: "Qty Ok harus lebih dari atau sama dengan 0", required: "Qty Ok harus diisi" },
				qtyPending: { validateQty: "Qty Pending harus lebih dari atau sama dengan 0" }
			},
			datas: Array(),
			selectAll: false,
			sortBy: '',
			sortDesc: '',
			pagingOptions: [
				{ value: '10', text: '10', selected: true },
				{ value: '25', text: '25' },
				{ value: '50', text: '50' },
				{ value: '100', text: '100' },
			],
			fieldsFinishGoodQualityInspectionNg: [
				{ "frontActions": { "class": "th-actions", "label": "" } },
				{ "no": { "class": "th-number d-stack-none" } },
				{ "problemCategory": { "class": "th-problem-category first-child", "label": "Problem Category", key: 'problemCategory', sortable: false } },
				{ "qtyNg": { "class": "th-qty-ng", "label": "Qty Ng", key: 'qtyNg', sortable: false } },
				{ "evidence": { "class": "th-evidence", "label": "Evidence", key: 'evidence', sortable: false}},
				{ "actions": { "class": "th-actions d-stack-show", "label": "" } }
			],
			fieldsFinishGoodQcConfirmation: [
				//{ "frontActions": { "class": "th-actions", "label": "" } },
				{ "mcc": { "class": "th-mcc first-child", "label": "PCC", key: 'mcc', sortable: false } },
				{ "status": { "class": "th-status", "label": "Control Card Status", key: 'status', sortable: false } },
			],
			finishGoodQcConfirmationDetails: [],
			finishGoodQcConfirmation: {},
			busy: false,
			isBusy: false,
			isDataLoading: false,
			selected: '',
			pageSizeOptions: 10,
			pageIndex: 0,
			sortingBy: Array(),
			modelId: null,
			model: {},
			modelFinishGoodQualityInspectionNg: {},
			isShowPopupFinishGoodQualityInspectionNg: false,
			isShowPopupUploadFinishGoodQualityInspectionNg: false,
			filterFinishGoodQualityInspection: null,
			currentFinishGoodQualityInspectionPage: 1,
			finishGoodQualityInspectionPageSize: 10,
			sortByFinishGoodQualityInspection: '',
			sortDescFinishGoodQualityInspection: '',
			filterFinishGoodQualityInspectionNg: null,
			currentFinishGoodQualityInspectionNgPage: 1,
			finishGoodQualityInspectionNgPageSize: 10,
			sortByFinishGoodQualityInspectionNg: '',
			sortDescFinishGoodQualityInspectionNg: '',
			sortingByFinishGoodQualityInspectionNg: [],
			finishGoodQualityInspectionNgs: [],
			finishGoodQualityInspectionNgId: '',
			totalFinishGoodQualityInspectionNgRow: 0,
			isShowFinishGoodQualityInspectionNgFilter: false,
			isDownloadFinishGoodQualityInspectionNg: false,
			problemCategorys: [],
			controlCards: [],
			isScanControlCardLoading: false,
			isControlCardsLoading: false,
			isControlCardComboLoading: false,
			metodeQcs: [],
			isMetodeQcComboLoading: false,
			parts: [],
			isPartComboLoading: false,
			workOrderProcessDetails: [],
			isWorkOrderProcessDetailComboLoading: false,
			isShowPopupConfirmation: false,
			isDataCommited: false,
			mainRecordId: '',
			isFinishGoodQualityInspectionComboLoading: false,
			isProblemCategoryComboLoading: false,
			scanPageIndex: 1,
			controlCardQrCode: '',
			filePendukungs: [],
			//hasContent: false,
		}
	},
	methods: {
		saveInputEvidenceAttachment(item) {
			this.isDataLoading = true;

			let id = item.id;
			let promises = Array();
			if (this.filePendukungs[id] != null) {
				this.isInputBusy = true;
				let data = new FormData();
				data.append('file', this.filePendukungs[id]);
				let _this = this;
				promises.push(this.$http.post('attachment/upload',
					data,
					{ headers: { 'Content-Type': 'multipart/form-data' } }
					).then(async function(response){
						if (response != null) {
							if (response.data != null) {
								item.evidenceId = response.data.id;
								item.evidence = response.data;
								//_this.filePendukungs[id] = null;
							}
						}

						_this.isInputBusy = false;
						return true;
					})
					.catch(error => {
						this.$store.dispatch('addErrorMessageGlobal', error);
						_this.isInputBusy = false;
						throw error;
					}));
			}
			else {
				item.evidence = null;
				item.evidenceId = null;
				this.filePendukungs[id] = null;
			}


			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					FinishGoodQualityInspectionNg.updateData(this, item, item.id);
				}

				this.isDataLoading = false;
			});
			this.isDataLoading = false;
		},
		deleteFinishGoodQcConfirmation() {return;},
		addDataFinishGoodQcConfirmation() {return;},
		createData() {
			this.isCreateBusy = true;
			FinishGoodQualityInspection.createData(this).then(async result => {
				if (result != null) {
					if (result.id != null && result.id != "") {
						let createRoute = 'finishgoodqualityinspectionedit';
						if (this.isScannerMode) {
							createRoute = 'finishgoodqualityinspectionscan';
						}
						this.modelId = result.id;
						await this.getFinishGoodQualityInspection(this.modelId);
						this.$router.push({ name: createRoute, params: { id: result.id } });
					}
				}
				this.isCreateBusy = false;
			}).catch(error => {
				this.isCreateBusy = false;
			})
		},
		finishAndSubmit: async function() {
			try {
				//console.log("parent confirm", this.finishGoodQcConfirmation);
				if(!this.finishGoodQcConfirmation || !this.finishGoodQcConfirmation.id) return;

				let id = this.finishGoodQcConfirmation.id;
				const response = await this.$http.put(`FinishGoodQcConfirmation/submit/${id}`);
				console.log("response", response);
				//console.log("response on finish and submit", response);
				if(response && response.status == 201) {
					this.$router.push({ name: 'finishgoodqualityinspectionindex' });
				} else {
					let error = "Gagal Submit Finish Good Quality Inspection";
					this.toast({message: error, title: 'System Error', variant: 'danger', autoHideDelay: 10000})	
				}
			} catch(error) {
				let errors = error.response.data.errors['1']
				this.toast({message: errors[0], title: 'System Error', variant: 'danger', autoHideDelay: 3000})
			}
		},
		getUnfinishedFinishGoodConfirmation: async function() {
			const response = await this.$http.get(`FinishGoodQualityInspection/getUnfinishedFinishGoodConfirmation`);
			if(response && response.data) {
				this.finishGoodQcConfirmation = response.data;
				this.finishGoodQcConfirmationDetails = response.data.finishGoodQcConfirmationDetail;
			}
		},
		getControlCardType: async function (code) {
			let filter = {};
			filter.code = code;
			let result = await ControlCardType.getList(this, filter, null, 0, 1);
			return result.data[0];
		},
		formatDate(date) {
			return moment(date).format('DD/MM/YYYY HH:mm')
		},
		async goToNext(page, item) {
			if(page == 1) {
				this.controlCardQrCode = '';
				this.scanPageIndex = page;
				await this.getUnfinishedFinishGoodConfirmation();
			}
			if (page == 2) {
				if (item != undefined) {
					this.controlCardQrCode = item.controlCardNumber;
				}

				if (this.controlCardQrCode == null || this.controlCardQrCode == "") {
					this.toast({ message: 'Control Card is required', title: 'Error', variant: 'danger' });
					return;
				}

				let controlCard = await this.scanControlCard();
				if (controlCard == undefined) {
					this.controlCardQrCode = null;
					return;
				}
				//let part = await this.getPart(item.partId);
				// this.model.qtyBefore = controlCard.qtyCase;
				// this.model.controlCardId = controlCard.id;
				this.getFinishGoodQualityInspection(this.modelId).then(result => {
					this.getFinishGoodQualityInspectionNgs().then(res => {
						this.scanPageIndex = page;
						this.model.controlCard = controlCard;
						this.model.partId = controlCard.partId;
					}).catch(err => {});

				}).catch(err => {});
				//this.model.controlCard.part = part;
			}
		},
		getPart: async function (id) {
			this.isBusy = true;
			let result = await Part.getData(this, id);
			this.isBusy = false;
			return result;
		},
		async scanControlCard() {
			let qrCode = encodeURIComponent(this.controlCardQrCode);
			let id = this.model.id;
			let this_ = this;
			this_.isBusy = true;
			try {
				let result = await FinishGoodQualityInspection.scanControlCard(this, id, qrCode);
				this_.isBusy = false;
				return result;
			} catch {

				this_.isBusy = false;
			}
		},
		getFinishGoodQualityInspection: async function (id) {
			this.isBusy = true;
			return await FinishGoodQualityInspection.getData(this, id).then(result => {
				this.model = result;
				this.mainRecordId = String(result.mainRecordId);
				let promises = Array();

				Promise.all(promises).then((results) => {
					this.isBusy = false;
				});
				return this.model;
			}).catch(error => { this.isBusy = false; });
		},
		downloadData() {
			this.isDownloadFinishGoodQualityInspection = true;
			this.filterFinishGoodQualityInspection.id = this.modelId;
			FinishGoodQualityInspection.downloadDataDetail(this, this.filterFinishGoodQualityInspection).then(result => {
				this.isDownloadFinishGoodQualityInspection = false;
			}).catch(error => { this.isDownloadFinishGoodQualityInspection = false; })
		},
		getFinishGoodQualityInspectionNgs: async function (isAddRow) {
			let filter = {};
			Object.assign(filter, this.filterFinishGoodQualityInspectionNg);
			if (this.modelId == null) return;
			filter.finishGoodQualityInspectionId = this.modelId;
			filter.draftMode = "1";
			// if (this.sortByFinishGoodQualityInspectionNg != null) {
			// 	this.sortingByFinishGoodQualityInspectionNg[this.sortByFinishGoodQualityInspectionNg] = this.sortDescFinishGoodQualityInspectionNg;
			// }
			let currentPage = (this.currentFinishGoodQualityInspectionNgPage - 1);
			if (isAddRow) {
				let totalData = this.totalFinishGoodQualityInspectionNgRow + 1;
				let page = Math.ceil(totalData / this.finishGoodQualityInspectionNgPageSize);
				currentPage = page - 1;
			}
			// disable paging start
			currentPage = null;
			this.finishGoodQualityInspectionNgPageSize = 0;
			// disable paging end
			FinishGoodQualityInspectionNg.getList(this, filter, this.sortingByFinishGoodQualityInspectionNg, currentPage, this.finishGoodQualityInspectionNgPageSize).then(async result => {
				this.currentFinishGoodQualityInspectionNgPage = currentPage + 1;
				this.finishGoodQualityInspectionNgs = result.data;
				this.totalFinishGoodQualityInspectionNgRow = result.dataCount;
				this.filePendukungs = Array();
				for(var item of result.data) {
					if (item.evidenceId) {
						let type = 'plain/txt';
						this.filePendukungs[item.id] = new File([await fetch(item.evidence.downloadUrl).then(r => r.blob())], item.evidence.originalFilename, { type: type });
					}
				}
			}).catch(error => { });
		},
		getFinishGoodQualityInspections: async function (input) {
			let filter = new FinishGoodQualityInspectionFilter();
			if (input != undefined) {
				filter.ControlCard = input;
			}
			this.isFinishGoodQualityInspectionComboLoading = true;
			FinishGoodQualityInspection.getList(this, filter, null, 0, 10)
				.then(result => {
					if (result != null) {
						this.finishGoodQualityInspections = result.data
					}
					this.isFinishGoodQualityInspectionComboLoading = false;
				})
				.catch(error => { });
		},
		getProblemCategorys: async function (input) {
			let filter = new ProblemCategoryFilter();
			if (input != undefined) {
				filter.code = input;
			}

			let existingIds = this.finishGoodQualityInspectionNgs.map(item => item.problemCategoryId).join(',');
			if (existingIds != null || existingIds.length > 0) {
				filter["idNotEquals"] = existingIds.replace(/,/g, '');
			}
			this.isProblemCategoryComboLoading = true;
			ProblemCategory.getList(this, filter, null, 0, 10)
				.then(result => {
					if (result != null) {
						this.problemCategorys = result.data
					}
					this.isProblemCategoryComboLoading = false;
				})
				.catch(error => { });
		},
		getControlCards: async function (input) {
			// let filter = new ControlCardFilter();
			// filter.controlCardStatusId = "OK";
			// filter.readyForFinishGoodQualityInspection = true;
			// filter.docNoNot = 'WAITING_FOR_APPROVAL,DONE';
			// if (input != undefined) {
			// 	filter.controlCardNumber = input;
			// }
			// filter.controlCardStatusId = "OK";
			//let controlCardType = await this.getControlCardType("PCC");
			//filter.controlCardTypeId = controlCardType.id;
			let url = `FinishGoodQualityInspection/getcontrolcardforfinishgood/`;

			if(input != undefined) {
				url += `?cardNumber=${input}`; 
			}

			try {
				const response = await this.$http.get(url);
				if(response && response.data) {
					console.log("response data", response.data);
					this.controlCards = response.data.data;
				}
			} catch (error) {
				this.$store.dispatch('addErrorMessageGlobal', error);
				throw error;
			}
			
			// ControlCard.getList(this, filter, null, 0, 10)
			// 	.then(result => {
			// 		if (result != null) {
			// 			this.controlCards = result.data
			// 		}
			// 	})
			// 	.catch(error => { });
		},
		setSelectedControlCard(item) {
			if (item == undefined || item == null) {
				this.model.controlCardId = null;
				this.model.controlCard = null;
			} else {
				this.model.controlCardId = item.id;
				this.model.controlCard = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		getMetodeQcs: async function (input) {
			let filter = new MetodeQcFilter();
			if (input != undefined) {
				filter.name = input;
			}
			MetodeQc.getList(this, filter, null, 0, 10)
				.then(result => {
					if (result != null) {
						this.metodeQcs = result.data
					}
				})
				.catch(error => { });
		},
		setSelectedMetodeQc(item) {
			if (item == undefined || item == null) {
				this.model.metodeQcId = null;
				this.model.metodeQc = null;
			} else {
				this.model.metodeQcId = item.id;
				this.model.metodeQc = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		getParts: async function (input) {
			let filter = new PartFilter();
			if (input != undefined) {
				filter.partNumber = input;
			}
			Part.getList(this, filter, null, 0, 10)
				.then(result => {
					if (result != null) {
						this.parts = result.data
					}
				})
				.catch(error => { });
		},
		setSelectedPart(item) {
			if (item == undefined || item == null) {
				this.model.partId = null;
				this.model.part = null;
			} else {
				this.model.partId = item.id;
				this.model.part = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		getWorkOrderProcessDetails: async function (input) {
			let filter = new WorkOrderProcessDetailFilter();
			if (input != undefined) {
				filter.part = input;
			}
			WorkOrderProcessDetail.getList(this, filter, null, 0, 10)
				.then(result => {
					if (result != null) {
						this.workOrderProcessDetails = result.data
					}
				})
				.catch(error => { });
		},
		setSelectedWorkOrderProcessDetail(item) {
			if (item == undefined || item == null) {
				this.model.workOrderProcessDetailId = null;
				this.model.workOrderProcessDetail = null;
			} else {
				this.model.workOrderProcessDetailId = item.id;
				this.model.workOrderProcessDetail = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		validateState(name) {
			if (!this.$v.model[name]) return null;
			const { $dirty, $error } = this.$v.model[name];
			return $dirty ? !$error : null;
		},
		getErrorMessage(message, name) {
			if (!this.$v.model[name]) return "";
			if (this.$v.model[name].required != undefined && !this.$v.model[name].required) {
				if (message.required) return message.required;
			}
			if (this.$v.model[name].validateQty != undefined && !this.$v.model[name].validateQty) {
				if (message.validateQty) return message.validateQty;
			}
		},
		handleScroll() {
			this.$refs.finishGoodQualityInspectionInput.scrollTop = 0;
		},
		saveAction(modalEvent) {
			if (modalEvent != undefined && modalEvent != null) {
				modalEvent.preventDefault();
			}
			this.handleScroll();
			let id = this.$route.params.id;
			this.$v.model.$touch();
			if (this.$v.model.$anyError) {
				return;
			} else {
				this.isBusy = true;
				let id = this.modelId;
				let model = this.model;
				FinishGoodQualityInspection.finishScan(this, id).then(result => {
					this.isDataCommited = true;
					this.createData();
					this.goToNext(1);
					//this.$router.push({ name: 'finishgoodqualityinspectionindex' });
					this.isBusy = false;
				}).catch(error => { this.isBusy = false; });
			}
		},
		updateData() {
			let id = this.modelId;
			let model = this.model;
			let promises = Array();

			this.$v.model.$touch();
			if (this.$v.model.$anyError) {
				return;
			}

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					FinishGoodQualityInspection.updateData(this, model, id)
						.catch((error) => {
							this.getFinishGoodQualityInspection(id);
						});
				}
			});
		},
		onHidden() {
			this.getFinishGoodQualityInspections();
		},
		addRowDataFinishGoodQualityInspectionNg(modalEvent, model) {
			if (model != null) {
				if (model.id != null && model.id != '') {
					model.finishGoodQualityInspectionId = this.modelId;
					FinishGoodQualityInspectionNg.updateDataDetail(this, model, model.id)
						.then(result => {
							this.getFinishGoodQualityInspectionNgs(true);
							this.isShowPopupFinishGoodQualityInspectionNg = false;
						})
				} else {
					model.finishGoodQualityInspectionId = this.modelId;
					FinishGoodQualityInspectionNg.createDataDetail(this, model)
						.then(result => {
							this.getFinishGoodQualityInspectionNgs(true);
							this.isShowPopupFinishGoodQualityInspectionNg = false;
						})
				}
			}
		},
		async editRowDataFinishGoodQualityInspectionNg(id) {
			this.finishGoodQualityInspectionNgId = id;
			this.isShowPopupFinishGoodQualityInspectionNg = true;
		},
		async deleteRowDataFinishGoodQualityInspectionNg(id) {
			FinishGoodQualityInspectionNg.deleteData(this, id).then(result => { this.getFinishGoodQualityInspectionNgs(); });
		},
		async resetDataFinishGoodQualityInspectionNg() {
			this.finishGoodQualityInspectionNgId = "";
			this.isShowPopupFinishGoodQualityInspectionNg = true;
		},
		async addDataFinishGoodQualityInspectionNg() {
			FinishGoodQualityInspectionNg.createData(this, { finishGoodQualityInspectionId: this.modelId })
				.then(result => {
					this.getFinishGoodQualityInspectionNgs(true);
				})
		},
		async addFromClipboardFinishGoodQualityInspectionNg() {
			let problemCategorys = new Array();
			navigator.clipboard.readText().then(value => {
				if (value.match(/(?:\r\n|\r|\n)/g)) { value = value.replace(/(?:\r\n|\r|\n)/g, ','); }
				let values = value.split(",");
				values.forEach(item => {
					problemCategorys.push({ problemCategory: item, finishGoodQualityInspectionId: this.modelId });
				});
				FinishGoodQualityInspectionNg.addFromClipboard(this, problemCategorys).then(result => { this.getFinishGoodQualityInspectionNgs() });
			});
		},
		async replaceFromClipboardFinishGoodQualityInspectionNg() {
			let problemCategorys = new Array();
			navigator.clipboard.readText().then(value => {
				if (value.match(/(?:\r\n|\r|\n)/g)) { value = value.replace(/(?:\r\n|\r|\n)/g, ','); }
				let values = value.split(",");
				values.forEach(item => {
					problemCategorys.push({ problemCategory: item, finishGoodQualityInspectionId: this.modelId });
				});
				FinishGoodQualityInspectionNg.replaceFromClipboard(this, problemCategorys).then(result => { this.getFinishGoodQualityInspectionNgs() });
			});
		},
		showPopupUploadFinishGoodQualityInspectionNg() {
			if (this.finishGoodQualityInspectionNgs != null && this.finishGoodQualityInspectionNgs.length > 0) {
				const msg = this.$createElement;
				const msgNode = msg('div', {
					domProps: {
						innerHTML: '<p>Perubahan terhadap FinishGoodQualityInspectionNg akan me-reset data yang sudah diinput sebelumnya.</p><p>Apakah anda yakin akan melanjutkan?</p>'
					}
				});
				this.$bvModal.msgBoxConfirm([msgNode], {
					title: 'Confirmation',
					size: 'sm',
					buttonSize: 'sm',
					okVariant: 'success',
					cancelVariant: 'danger',
					okTitle: 'Yes',
					cancelTitle: 'No',
					footerClass: 'p-2',
					hideHeaderClose: false,
					centered: true
				})
					.then(value => {
						if (value) {
							this.isShowPopupUploadFinishGoodQualityInspectionNg = true;
						}
					})
					.catch(err => { })
			} else {
				this.isShowPopupUploadFinishGoodQualityInspectionNg = true;
			}
		},
		uploadDataFinishGoodQualityInspectionNg(modalEvent, newDatas) {
			this.isShowPopupUploadFinishGoodQualityInspectionNg = false;
		},
		downloadFinishGoodQualityInspectionNg(modalEvent) {
			this.isDownloadFinishGoodQualityInspectionNg = true;
			this.filterFinishGoodQualityInspectionNg.finishGoodQualityInspectionId = this.modelId;
			FinishGoodQualityInspectionNg.downloadDataDetail(this, this.filterFinishGoodQualityInspectionNg).then(result => {
				this.isDownloadFinishGoodQualityInspectionNg = false;
			}).catch(error => { this.isDownloadFinishGoodQualityInspectionNg = false; })
		},
		saveInputFinishGoodQualityInspectionNg(item) {
			if (this.finishGoodQualityInspections != null && this.finishGoodQualityInspections != undefined && this.finishGoodQualityInspections.length > 0) {
				item.finishGoodQualityInspection = this.finishGoodQualityInspections.find(q => q.id == item.finishGoodQualityInspectionId);
			}
			if (this.problemCategorys != null && this.problemCategorys != undefined && this.problemCategorys.length > 0) {
				item.problemCategory = this.problemCategorys.find(q => q.id == item.problemCategoryId);
			}

			let id = item.id;
			let promises = Array();

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					FinishGoodQualityInspectionNg.updateData(this, item, item.id);
				}
			});
		},
		resetModal(modalType) {
			this.controlCardQrCode = '';
			this.isShowPopupUploadFinishGoodQualityInspectionNg = false;
			this.isShowPopupFinishGoodQualityInspectionNg = false;
			if (modalType == 'FinishGoodQualityInspectionNg') {
				this.getFinishGoodQualityInspectionNgs();
			}
			this.showPopupCopyData = false;
			this.isShowPopupConfirmation = false;
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768) {
				//this.isShowFinishGoodQualityInspectionNgFilter = true;
			}
		},
	},
	beforeMount() {
		this.filterFinishGoodQualityInspection = new FinishGoodQualityInspectionFilter();
		this.filterFinishGoodQualityInspectionNg = new FinishGoodQualityInspectionNgFilter();
		//this.getFinishGoodQualityInspections();
		//this.getProblemCategorys();
		//this.getControlCards();
		this.getMetodeQcs();
		//this.getParts();
		//this.getWorkOrderProcessDetails();
	},
	async mounted() {
		let id = this.$route.params.id;
		let copyData = this.$route.params.copydata;
		if (id != '' && id != null && id != undefined) {
			if (copyData != null && copyData != undefined) {
				await this.getFinishGoodQualityInspection(id);
			} else {
				this.modelId = id;
				await this.getFinishGoodQualityInspection(id);
			}
		}
		this.$nextTick(async () => {
			await this.getControlCards();
			await this.getUnfinishedFinishGoodConfirmation();
			window.addEventListener('resize', this.displayFilter);
			this.displayFilter();
		});
	},
	computed: {
		showAttachment() {
			if(this.finishGoodQualityInspectionNgs.length > 0)
				return true;

			return false;
		},
		hasContent() {
			if(this.finishGoodQcConfirmationDetails.length > 0) return true;

			return false;
		},
		isAllowSaveDraft: {
			get: function () {
				return true;
			}
		}
	},
	watch: {
		controlCardQrCode(newValue) {
			this.getControlCards(newValue)
		},
		sortByFinishGoodQualityInspectionNg: {
			handler: function () {
				this.getFinishGoodQualityInspectionNgs();
			}
		},
		sortDescFinishGoodQualityInspectionNg: {
			handler: function () {
				this.getFinishGoodQualityInspectionNgs();
			}
		},
		currentFinishGoodQualityInspectionNgPage: {
			handler: function () {
				this.getFinishGoodQualityInspectionNgs();
			}
		},
		finishGoodQualityInspectionNgPageSize: {
			handler: function () {
				this.getFinishGoodQualityInspectionNgs();
			}
		},
		filterFinishGoodQualityInspectionNg: {
			handler: function () {
				this.getFinishGoodQualityInspectionNgs();
			},
			deep: true,
		},
		scanPageIndex() {
			this.hideToast();
		}
	},
}
</script>
